import React, { useEffect, useState, useRef } from "react";
import { Link, NavLink, useNavigate, useLocation } from "react-router-dom";
import styled from "styled-components";
import Logo from "../assets/Horizon_logo_192x192.png";
import hamburgerIcon from "../assets/whoweare/icons8-menu-50.png";
import ParticleSystem from "./particles";

const FEATURES = [
  {
    id: "feature-1",
    Image_URL: require("../assets/vivre/HospitalityLogo.png"),
    Title: "VIVRE",
    Disc: "Experience. Engage. Monetize",
    link: "/product/vivre",
  },
  {
    id: "feature-7",
    Image_URL: require("../assets/nsara/f2576786-dfec-449f-9b0b-b820983d0f0d-removebg-preview.png"),
    Title: "Content Eye",
    Disc: "Analyse Content. Ensure Compliance",
    link: "/product/contentEye",
  },
  {
    id: "feature-6",
    Image_URL: require("../assets/products/reelcraft-removebg-preview.png"),
    Title: "ReelCraft",
    Disc: "Promote Content. Enrich Metadata. Commercialise",
    link: "/product/reelcraft",
  },
  {
    id: "feature-2",
    Image_URL: require("../assets/aboutus/Sara.png"),
    Title: "SARA",
    Disc: "Content Discovery. Immersive. Monetize",
    link: "/product/sara",
  },
  {
    id: "feature-5",
    Image_URL: require("../assets/products/HZAD.png"),
    Title: "AdPilot",
    Disc: "Promote . Analytics . Monetize",
    link: "/product/adpilot",
  },
  {
    id: "feature-4",
    Image_URL: require("../assets/hospitality/logo1.png"),
    Title: "Hospitality",
    Disc: "Entertainment.Hotel Service Aggregation",
    link: "/product/hospitality",
  },
  {
    id: "feature-3",
    Image_URL: require("../assets/nblink/Saralogo.png"),
    Title: "Blinks",
    Disc: "User Generated Content. Gamification",
    link: "/product/blink",
  },
];


// Styled Components
const Container = styled.div`
  position: static !important;
  height: 65px;
  top: 0;
  z-index: 999;
  width: 100%;
  background: black;
  padding: 15px 30px;
  display: flex;
  justify-content: space-between;
  align-items: center;

  @media (max-width: 768px) {
    padding: 10px 20px;
  }

  @media (min-width: 768px) {
    position: sticky;
    justify-content: center;
  }
`;

const LogoContainer = styled.div`
  position: relative;
  top: 8px;
  left: 12px;
  z-index: 1000;
  img {
    height: 50px;
  }

  @media (max-width: 768px) {
    position: relative;
    top: 6px;
    left: 5px;
  }
`;

const Navbar = styled.nav`
  display: flex;
  gap: 20px;
  align-items: center;
  @media (max-width: 768px) {
    display: none;
  }
`;

const StyledNavLink = styled(NavLink)`
  font-size: 18px;
  font-weight: 600;
  text-decoration: none;
  padding: 6px 10px;
  color: #fff;
  position: relative;

  &::after {
    content: "";
    position: absolute;
    left: 0;
    bottom: 0;
    height: 3px;
    width: 100%;
    background-color: #6054e4;
    transform: scaleX(0);
    transform-origin: left;
    transition: transform 0.4s ease-out;
  }

  &.active {
    color: #6054e4;
  }

  &.active::after {
    transform: scaleX(1);
  }

  &:hover {
    color: #6054e4;
  }

  &:hover::after {
    transform: scaleX(1);
  }
`;

const DropdownMenu = styled.div`
  position: relative;
  display: inline-block;
`;

const DropdownContent = styled.div.attrs((props) => ({
  style: {
    top: `${props.navbarHeight}px`,
  },
}))`
  display: ${({ open }) => (open ? "grid" : "none")};
  opacity: ${({ open }) => (open ? 1 : 0)};
  transform: ${({ open }) =>
    open ? "translateY(0)" : "translateY(-10px)"};
  transition: opacity 0.3s ease, transform 0.3s ease;
  position: fixed;
  left: 0;
  width: 100vw;
  background: black;
  backdrop-filter: blur(6px);
  z-index: 998;
  padding: 20px 20px;
grid-auto-flow: column;
grid-auto-columns: minmax(200px, 1fr);
  gap: 16px;
`;


const TiltCard = styled(Link)`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  padding: 20px;
  background: rgba(255, 255, 255, 0.25);
  border: 1.5px solid rgba(0, 0, 0, 0.1);
  border-radius: 12px;
  text-decoration: none;
  color: #333;
  font-size: 16px;
  cursor: pointer;
  transition: background-color 0.3s ease, box-shadow 0.3s ease;
  transform-style: preserve-3d;
  perspective: 1000px;

  img {
    width: 50px;
    height: 50px;
    object-fit: contain;
    margin-bottom: 12px;
    transition: transform 0.3s ease;
  }

  .title {
    font-weight: bold;
    font-size: 18px;
    margin-bottom: 6px;
    transition: transform 0.3s ease;
  }

  .desc {
    font-size: 14px;
    color: #ffff;
    transition: color 0.3s ease, transform 0.3s ease;
  }

  &:hover {
    background: linear-gradient(to left, #ffffff, #8ab9ff);
    box-shadow: 0 15px 35px rgba(0, 0, 0, 0.15);
    border-color: rgba(0, 0, 0, 0.15);

    .desc {
      color: #333;
    }

    img {
      transform: translateZ(20px);
    }

    .title {
      transform: translateZ(15px);
    }

    .desc {
      transform: translateZ(10px);
    }
  }
`;

const Hamburger = styled.div`
  display: none;

  @media (max-width: 768px) {
    display: block;
    font-size: 24px;
    cursor: pointer;
  }
`;

const MobileMenu = styled.div`
  display: ${({ open }) => (open ? "flex" : "none")};
  flex-direction: column;
  position: absolute;
  top: 64px;
  left: 0;
  background: black;
  width: 100%;
  padding: 15px;
  z-index: 100;
  align-items: center;

  a {
    padding: 10px;
    text-decoration: none;
    font-weight: 600;
    color: #fff;
    text-align: center;

    &:active {
      color: #ffff !important;
    }
  }

  @media (min-width: 769px) {
    display: none;
  }
`;

// Tilt effect hook
const useParallaxTilt = () => {
  const ref = useRef(null);

  useEffect(() => {
    const element = ref.current;
    if (!element) return;

    const handleMouseMove = (e) => {
      const rect = element.getBoundingClientRect();
      const centerX = rect.left + rect.width / 2;
      const centerY = rect.top + rect.height / 2;

      const mouseX = e.clientX - centerX;
      const mouseY = e.clientY - centerY;

      const rotateX = (mouseY / (rect.height / 2)) * -25;
      const rotateY = (mouseX / (rect.width / 2)) * 25;

      element.style.transition =
        "transform 0.1s ease-out, background-color 0.3s ease, box-shadow 0.3s ease";
      element.style.transform = `
        perspective(1000px) 
        rotateX(${rotateX}deg) 
        rotateY(${rotateY}deg) 
        translateY(-7px) 
        scale(1.03)
      `;
    };

    const handleMouseLeave = () => {
      element.style.transition =
        "transform 0.6s cubic-bezier(0.25, 0.46, 0.45, 0.94), background-color 0.3s ease, box-shadow 0.3s ease";
      element.style.transform = `
        perspective(1000px) 
        rotateX(0deg) 
        rotateY(0deg) 
        translateY(0px) 
        scale(1)
      `;
    };

    element.addEventListener("mousemove", handleMouseMove);
    element.addEventListener("mouseleave", handleMouseLeave);

    return () => {
      if (element) {
        element.removeEventListener("mousemove", handleMouseMove);
        element.removeEventListener("mouseleave", handleMouseLeave);
      }
    };
  }, []);

  return ref;
};

const TiltCardComponent = ({ feature, onClick }) => {
  const tiltRef = useParallaxTilt();

  return (
    <TiltCard
      ref={tiltRef}
      key={feature.id}
      to={feature.link}
      onClick={() => onClick(feature.link)}
    >
      <img src={feature.Image_URL} alt={feature.Title} />
      <div className="title">{feature.Title}</div>
      <div className="desc">{feature.Disc}</div>
    </TiltCard>
  );
};

const Top = () => {
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const [navbarHeight, setNavbarHeight] = useState(65);
  const [issticky, setIssticky] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const containerRef = useRef(null);

  const handleDropdownClick = (link) => {
    setDropdownOpen(false);
    navigate(link);
  };

  // Calculate navbar height and sticky state
  useEffect(() => {
    const updateNavbarHeight = () => {
      if (containerRef.current) {
        const rect = containerRef.current.getBoundingClientRect();
        setNavbarHeight(rect.bottom);
        setIssticky(rect.top <= 0);
      }
    };

    const handleScroll = () => {
      updateNavbarHeight();
    };

    const handleResize = () => {
      updateNavbarHeight();
    };

    // Initial calculation
    updateNavbarHeight();

    window.addEventListener("scroll", handleScroll);
    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("scroll", handleScroll);
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  // Close dropdown when clicking outside or scrolling away
  // useEffect(() => {
  //   const handleClickOutside = (event) => {
  //     if (containerRef.current && !containerRef.current.contains(event.target)) {
  //       setDropdownOpen(false);
  //     }
  //   };

    const handleScroll = () => {
      // Close dropdown if navbar is not visible or user scrolls significantly
      // if (containerRef.current) {
      //   const rect = containerRef.current.getBoundingClientRect();
      //   if (rect.bottom < 0) {
      //     setDropdownOpen(false);
      //   }
      // }
    };

  //   document.addEventListener("mousedown", handleClickOutside);
  //   window.addEventListener("scroll", handleScroll);

  //   return () => {
  //     document.removeEventListener("mousedown", handleClickOutside);
  //     window.removeEventListener("scroll", handleScroll);
  //   };
  // }, []);

  // Open dropdown automatically when on /products
  useEffect(() => {
    if (location.pathname.startsWith("/products")) {
      setDropdownOpen(true);
    } else {
      setDropdownOpen(false);
    }
  }, [location.pathname]);

  // Handle hover events for dropdown
  const handleMouseEnter = () => {
    if (location.pathname.startsWith("/products") || !location.pathname.startsWith("/product")) {
      setDropdownOpen(true);
    }
  };

  const handleMouseLeave = () => {
    if (!location.pathname.startsWith("/products")) {
      setDropdownOpen(false);
    }
  };

  return (
    <div style={{ position: "relative", display: "flex" }}>
      <LogoContainer>
        <Link to="/">
          <img src={Logo} alt="logo" />
        </Link>
      </LogoContainer>
      <Container ref={containerRef}>
        <ParticleSystem />

        <div style={{ display: "flex", alignItems: "center", gap: "20px" }}>
          <Navbar>
            <StyledNavLink exact="true" to="/">
              Home
            </StyledNavLink>
            <StyledNavLink to="/solutions">Solutions</StyledNavLink>

            <DropdownMenu
              // onMouseEnter={handleMouseEnter}
              // onMouseLeave={handleMouseLeave}
            >
              <StyledNavLink to="/products">Products</StyledNavLink>
              <DropdownContent 
                open={dropdownOpen} 
                navbarHeight={navbarHeight}
                isSticky={issticky}
              >
                {FEATURES.map((feature) => (
                  <TiltCardComponent
                    key={feature.id}
                    feature={feature}
                    onClick={handleDropdownClick}
                  />
                ))}
              </DropdownContent>
            </DropdownMenu>

            <StyledNavLink to="/customers">Customers</StyledNavLink>
            <StyledNavLink to="/resources">Resources</StyledNavLink>
            <StyledNavLink to="/about">About Us</StyledNavLink>
          </Navbar>

          <Hamburger onClick={() => setMobileOpen(!mobileOpen)}>
            <img src={hamburgerIcon} alt="" style={{ height: "25px" }} />
          </Hamburger>
        </div>

        {/* Mobile Navigation */}
        <MobileMenu open={mobileOpen}>
          <Link to="/" onClick={() => setMobileOpen(false)}>
            Home
          </Link>
          <Link to="/solutions" onClick={() => setMobileOpen(false)}>
            Solutions
          </Link>
          <Link to="/products" onClick={() => setMobileOpen(false)}>
            Products
          </Link>
          <Link to="/customers" onClick={() => setMobileOpen(false)}>
            Customers
          </Link>
          <Link to="/resources" onClick={() => setMobileOpen(false)}>
            Resources
          </Link>
          <Link to="/about" onClick={() => setMobileOpen(false)}>
            About Us
          </Link>
        </MobileMenu>
      </Container>
    </div>
  );
};

export default Top;